// extracted by mini-css-extract-plugin
export default {"wrapper":"CarteiraSelector_wrapper__75aXG","carteiraSelect":"CarteiraSelector_carteiraSelect__qu4ip"};